import { mediaQuerySm, mediaQueryMd, mediaQueryLg, mediaQueryXl, mediaQueryXxl } from './media-query';
import { navMenuMobile } from './header';
import { observer, observerDistant, observerFromTop } from './observer';
import { smooth_scroll } from './smooth-scroll';


// 関数同士の干渉を防ぐために、初期化関数を使って実装
class AppInitializer {
  constructor() {
    this.initializationQueue = [];
  }

  addInitializer(name, initFunction) {
    this.initializationQueue.push({ name, initFunction });
  }

  async initialize() {
    for (const { name, initFunction } of this.initializationQueue) {
      try {
        await initFunction();
        // console.log(`${name} initialized successfully`);
      } catch (error) {
        // console.error(`Error initializing ${name}:`, error);
      }
    }
  }
}
const appInitializer = new AppInitializer();


// 各機能の初期化関数を追加

// リンク無効化
appInitializer.addInitializer('Link Ignore', async () => {
  const ignoreLinks = document.querySelectorAll('a.ignore');
  ignoreLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
    });
  });
});

// スマホメニュー
appInitializer.addInitializer('Navigation', async () => {
  navMenuMobile();
});

// Observer
appInitializer.addInitializer('Observer', async () => {
  if (mediaQueryLg.matches) {
    // observerFromTop('#grobal__header', 'js-scroll', '150px', false, false);
    observerFromTop('#js-fadeButton-pagetop', 'js-scroll', '250px', false, false);
  } else {
    // observerFromTop('#grobal__header', 'js-scroll', '30px', false, false);
  }
});


// Smooth Scroll
appInitializer.addInitializer('Smooth Scroll', async () => {
  smooth_scroll();
});


// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
  appInitializer.initialize();
});


